module.exports = __webpack_public_path__ + "img/Telegram.c94cc570.svg";